module.exports = __webpack_public_path__ + "static/img/newsbanner.1a491a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/newsbanner.png
// module id = RcS/
// module chunks = 10